import { Alert, AlertIcon, ChakraProvider, Stack, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import React, { Component, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
// import { apiUrl, appRootPathPrefix } from '../../config'
import { session } from '../../config'
import { history } from '../../redux/history'
import { Loader } from '../common'
import { identityServices } from '../common/index'

class SlaComponent1 extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			editMode: false,
			errorMsg: null,
			tenantId: null,
			formMeta: this.props && this.props.meta && this.props.meta.fields && this.props.meta.fields ? this.props.meta.fields : {},
			properties: {
				label: 'queue ticketing',
				priority: {
					low: {
						sla: 24*60,
						position: 4,
					},
					high: {
						sla: 4*60,
						position: 2,
					},
					medium: {
						sla: 8*60,
						position: 3,
					},
					critical: {
						sla: 1*60,
						position: 1,
					},
					verylow: {
						sla: 168*60,
						position: 5,
					},
				},
			},
			formValues: { metricName: '', label: '', properties: {}, status: '', levels: [], metricFor: 'queue', conditionName: 'default' },
		}
		this.handleChange = this.handleChange.bind(this)
		this.handleCalendarChange = this.handleCalendarChange.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
	}
	async componentDidMount() {
		let props = this.props
		let { t } = this.props
		if (props && props.params && props.params.itemId) {
			this.setState({ loading: true })
			await this.props.getOne({ filter: [{ name: 'id', value: props.params.itemId }], t })
		}
		if (props && props.meta && props.meta.fields && props.meta.fields) {
			this.setState({ formMeta: props.meta.fields })
		}
	}
	//ORIGINAL CODE
	// componentWillReceiveProps(props) {
	// 	const { entity, profile } = props
	// 	this.setState({ tenantId: profile.tenantUid || null })
	// 	if (entity && entity.entityValues && typeof entity.entityValues === 'object' && Object.keys(entity.entityValues).length > 0) {
	// 		let entityValue = entity.entityValues
	// 		this.setState({ formValues: entityValue, loading: entity.loading, editMode: true })
	// 		if (entityValue.properties) {
	// 			this.setState({ properties: entityValue.properties })
	// 		}
	// 	} else {
	// 		this.setState({
	// 			formValues: { metricName: '', label: '', properties: [], status: '', metricFor: 'queue', conditionName: 'default' },
	// 			editMode: false,
	// 		})
	// 	}
	// }

	//FIRST WORKING CODE PRD-745
	// componentWillReceiveProps(props) {
	// 	const { entity, profile } = props
	// 	this.setState({ tenantId: profile.tenantUid || null })
	  
	// 	if (entity && entity.entityValues && typeof entity.entityValues === 'object' && Object.keys(entity.entityValues).length > 0) {
	// 	  let entityValue = entity.entityValues
	// 	  // Multiply the properties.priority[item].sla values by 60 during GET
	// 	  if (entityValue.properties) {
	// 		const propertiesCopy = { ...entityValue.properties }
	// 		Object.keys(propertiesCopy.priority).forEach(item => {
	// 		  propertiesCopy.priority[item].sla *= 60
	// 		})
	// 		entityValue.properties = propertiesCopy
	// 		this.setState({ properties: entityValue.properties })
	// 	  }
	// 	  this.setState({ formValues: entityValue, loading: entity.loading, editMode: true })
	// 	} else {
	// 	  this.setState({
	// 		formValues: { metricName: '', label: '', properties: [], status: '', metricFor: 'queue', conditionName: 'default' },
	// 		editMode: false,
	// 	  })
	// 	}
	//   }

	//bug fix for fetching latest values in input fields PRD-745
	componentDidUpdate(prevProps) {
		const { entity, profile } = this.props
		if (prevProps.entity !== this.props.entity) {
		  this.setState({ tenantId: profile.tenantUid || null })
	
		  if (entity && entity.entityValues && typeof entity.entityValues === 'object' && Object.keys(entity.entityValues).length > 0) {
			let entityValue = entity.entityValues
			// Multiply the properties.priority[item].sla values by 60 during GET
			if (entityValue.properties) {
			  const propertiesCopy = { ...entityValue.properties }
			  Object.keys(propertiesCopy.priority).forEach(item => {
				propertiesCopy.priority[item].sla = Math.ceil(propertiesCopy.priority[item].sla * 60)
			  })
			  entityValue.properties = propertiesCopy
			  this.setState({ properties: entityValue.properties })
			}
			this.setState({ formValues: entityValue, loading: entity.loading, editMode: true })
		  } else {
			this.setState({
			  formValues: { metricName: '', label: '', properties: [], status: '', metricFor: 'queue', conditionName: 'default' },
			  editMode: false,
			})
		  }
		}
	  }

	  
	handleFieldApi = async config => {
		const { profile } = this.props
		let apiUrl = session.get('apiUrl') || sessionStorage.getItem('apiUrl') || localStorage.getItem('apiUrl')
		let apiUrlCustom = profile.tenantUid !== undefined && profile.tenantUid !== null ? `${apiUrl}/ticketing` : apiUrl
		if (config && config && config.apiUrl) {
			let endPoint = config.apiUrl.replace(/`/g, "'")
			const requestOptions = {
				method: 'GET',
				headers: { Pragma: 'no-cache', 'Content-Type': 'application/json', clientApp: window.location.pathname.split('/')[1] },
				url: `${apiUrlCustom}${endPoint}${config.filter || ''}`,
			}
			// @ts-ignore
			let response = await identityServices.identityApi.request(requestOptions)
			if (response && response.status && response.status === 200) {
				if (response && response.data && response.data.rows) {
					response.data = response.data.rows
				}
				return response.data
			} else return false
		} else return false
	}

	toCamelCase = str => {
		return str.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
			if (p2) return p2.toUpperCase()
			return p1.toLowerCase()
		})
	}
	typeModal(item) {
		const {
			meta: { categoriesMeta },
		} = this.props
		if (categoriesMeta && categoriesMeta[item]) return categoriesMeta[item]
	}

	handleCalendarChange(name, item) {
		this.setState({
			[name]: item,
		})
	}
	handleChange(event) {
		const { formValues } = this.state
		if (event.target.name === 'metricName') event.target.value = this.toCamelCase(event.target.value).trim()

		this.setState({
			formValues: {
				...formValues,
				[event.target.name]: event.target.value,
			},
		})
	}

	setLevels(priority) {
		let levels = []
		if (priority) {
			priority &&
				typeof priority === 'object' &&
				Object.keys(priority).map((item, idx) => {
					let obj = {
						priority: item,
						sla_level: priority[item].sla || 0,
					}
					levels.push(obj)
				})
		}
		return levels
	}
	// onSubmit(e) {
	// 	e.preventDefault()
	// 	const { formValues, properties } = this.state
	// 	let value = { ...formValues, properties }
	// 	let { t } = this.props
	// 	value.levels = this.setLevels(properties.priority || null)
	// 	this.setState({ loading: true })
	// 	this.props.upsertItem({ entityValues: value, t })
	// 	setTimeout(() => {
	// 		this.setState({ loading: false })
	// 	}, 300)
	// }
	onSubmit(e) {
		e.preventDefault()
		const { formValues, properties } = this.state
		let value = { ...formValues, properties }
		let { t } = this.props
		// Divide the properties.priority[item].sla values by 60 during POST
		Object.keys(value.properties.priority).forEach((item) => {
			value.properties.priority[item].sla = parseFloat((value.properties.priority[item].sla / 60))
			// or
			// value.properties.priority[item].sla = Number((value.properties.priority[item].sla / 60).toFixed(2));
		  })
		value.levels = this.setLevels(properties.priority || null)
		this.setState({ loading: true })
		this.props.upsertItem({ entityValues: value, t })
		setTimeout(() => {
		  this.setState({ loading: false })
		}, 300)
	  }
	  
	async delete() {
		const { formValues } = this.state
		this.setState({ loading: true })
		let { t } = this.props
		formValues.status = 'Deleted'
		let config = { apiUrl: '/queue', filter: `?$filter=slaGoals eq '${formValues.metricName}'` }
		let checkExists = await this.handleFieldApi(config)
		if (checkExists && checkExists.length > 0) {
			this.setState({ errorMsg: `Cannot Delete "${formValues.label}" as this is tagged to "${checkExists[0].queueName}" Queue` })
		} else {
			this.props.upsertItem({ entityValues: formValues, t })
			this.setState({ errorMsg: null })
		}
		setTimeout(() => {
			this.setState({ loading: false })
		}, 300)
	}
	back() {
		history.goBack()
	}
	render() {
		const { t } = this.props
		const { loading, formValues, formMeta, editMode, properties, errorMsg } = this.state
		return (
			<div className="animated fadeIn">
				{loading && <Loader />}
				<div className="main-section">
					<div className="main-inner">
						<div className="common-heading">
							<div className="row table-title">
								<div className="col-sm-6">
									<div className="heading">
										<h5>{t('SLA Goals')}</h5>
									</div>
								</div>
								<div className="col-sm-6">
									<Button color="link" className="pull-right" onClick={e => history.goBack()}>
										{t('Back to List')}
									</Button>
								</div>
							</div>
						</div>
						<section>
							{errorMsg && <AlertBox status="error" title="Cannot Delete" msg={errorMsg} t={this.props.t} />}

							<Form onSubmit={this.onSubmit} className="col-sm-6">
								<pre>{JSON.stringify(this.state.timeZoneList, null, 2)}</pre>
								{formMeta &&
									Object.keys(formMeta).map((field, idx) => {
										let formField = formMeta[field]
										if (formField.create) {
											return (
												<FormGroup className="row" key={idx}>
													<div className="col-sm-3">
														<Label for="exampleEmail">{formField && formField.label ? t(formField.label) : 'Field Name'}</Label>
													</div>
													<div className="col-sm-9">
														{formField && formField.type === 'select' && (
															<Input
																type={formField && formField.type ? formField.type : 'text'}
																name={formField && formField.name ? formField.name : 'formField'}
																value={formValues && formValues[formField.name]}
																className="col-sm-4"
																placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
																required={(formField && formField.required) || false}
																onChange={this.handleChange}
																disabled={formField && formField.readOnlyOnEdit && editMode}>
																<option value="">{t('--Select--')}</option>
																{formField &&
																	formField.options &&
																	Array.isArray(formField.options) &&
																	formField.options.map((elem, id) => (
																		<option key={id} value={elem.value}>
																			{t(elem.label)}
																		</option>
																	))}
															</Input>
														)}
														{formField && formField.type === 'text' && (
															<Input
																type={formField && formField.type ? formField.type : 'text'}
																name={formField && formField.name ? formField.name : 'formField'}
																value={formValues && formValues[formField.name]}
																placeholder={formField && formField.placeholder ? t(formField.placeholder) : ''}
																required={(formField && formField.required) || false}
																onChange={this.handleChange}
																disabled={formField && formField.readOnlyOnEdit && editMode}
															/>
														)}

														{formField && formField.type === 'jsonObj' && formField.name === 'properties' && (
															<TypeModal {...this.props} handleChange={this.handleCalendarChange} meta={properties} config={formField} />
														)}
													</div>
												</FormGroup>
											)
										}
									})}
								<FormGroup>
									<div className="pull-right">
										{editMode && formValues.tenantId === this.state.tenantId && (
											<Button onClick={this.delete.bind(this, formValues.id)} style={{ cursor: 'pointer' }} color="danger">
												{t('Delete')}
											</Button>
										)}{' '}
										<Button className="min-btn pull-right">{editMode ? t('Update') : t('Create')}</Button>
									</div>
									<div className="clearfix"></div>
								</FormGroup>
							</Form>
						</section>
					</div>
				</div>
			</div>
		)
	}
}
export const SlaComponent = withTranslation()(SlaComponent1)
const TypeModal = props => {
	const { meta, config, t } = props
	const [properties, setCalendar] = useState(meta)

	const sortByPosition = obj => {
		const order = [],
			res = {}
		Object.keys(obj).forEach(key => (order[obj[key]['position'] - 1] = key))
		order.forEach(key => (res[key] = obj[key]))
		return res
	}

	useEffect(() => {
		if (meta) {
			let obj = meta
			obj.priority = sortByPosition(obj.priority)
			setCalendar(obj)
		}
	}, [meta])
	const onChange = (item, e) => {
		let name = e.target.name
		let value = parseInt(e.target.value)
		let itm = properties.priority[item]
		itm[name] = value
		// properties.priority = { ...properties.priority, ...itm }
		props.handleChange(config.name, properties)
	}
	const strToUpper = string => {
		return string.charAt(0).toUpperCase() + string.slice(1)
	}
	return (
		<div className="calendar">
			<ChakraProvider>
				<Table size="sm">
					<Thead>
						<Tr>
							<Th>{t('Priority')}</Th>
							<Th>{t('Time to Close in (MINUTES)')}</Th>
						</Tr>
					</Thead>
					<Tbody>
						{properties &&
							properties.priority &&
							typeof properties.priority === 'object' &&
							Object.keys(properties.priority).map((item, idx) => {
								return (
									<Tr key={idx}>
										<Td>{strToUpper(t(item))}</Td>
										<Td>
											<Input bsSize="sm" type="number" name="sla" value={parseInt(properties.priority[item].sla) || ''} onChange={onChange.bind(this, item)} />
										</Td>
									</Tr>
								)
							})}
					</Tbody>
				</Table>
			</ChakraProvider>
		</div>
	)
}

const AlertBox = props => {
	let { t } = props
	return (
		<Stack spacing={3}>
			<Alert status={props.status} variant="solid">
				<AlertIcon />
				{(t && t(props.msg)) || props.msg}
			</Alert>
			<br />
		</Stack>
	)
}
